import script from "./ImportBulkTopicsCsv.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportBulkTopicsCsv.vue?vue&type=script&setup=true&lang=js"

import "./ImportBulkTopicsCsv.vue?vue&type=style&index=0&id=6cfb23e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfb23e6"]])

export default __exports__